/**
 * @Author: zachalam
 * @Date:   2017-01-04T13:20:10-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T16:35:07-07:00
 */

import React, { Component } from "react";
import glamorous from "glamorous";

import SearchHomeInput from "./SearchHomeInput";
import ExploreMembers from "./ExploreMembers";
import UpcomingTrips from "./UpcomingTrips";
import PeopleNearMe from "./PeopleNearMe";
import TopDestinations from "./TopDestinations";
import MTFooter from "../../blocks/MTFooter";
import Destinations from "../../../config/Destinations";

const PageStyle = glamorous.div({
  backgroundColor: "#231035",
  color: "#fff",
  minHeight: "100vh"
});

class SearchHome extends Component {
  render() {
    const { search, favToggle, joinTrip, dropInSearchResults } = this.props;

    return (
      <PageStyle>
        <SearchHomeInput dropInSearchResults={dropInSearchResults} />
        <ExploreMembers
          favToggle={favToggle}
          members={search.search_explore_members}
          dropInSearchResults={dropInSearchResults}
        />
        <UpcomingTrips
          joinTrip={joinTrip}
          trips={search.search_upcoming_trips}
          dropInSearchResults={dropInSearchResults}
        />
        <PeopleNearMe
          favToggle={favToggle}
          members={search.search_people_near_me}
          dropInSearchResults={dropInSearchResults}
        />
        <TopDestinations
          destinations={Destinations}
          dropInSearchResults={dropInSearchResults}
        />
        <MTFooter />
      </PageStyle>
    );
  }
}

export default SearchHome;



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchHome.jsx